import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { Card } from '../components/ui/Card';
import { ArrowLeft } from 'lucide-react';
export function Login() {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const {
    login
  } = useAuth();
  const navigate = useNavigate();
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    // Simulate API call
    setTimeout(() => {
      login(email);
      setIsLoading(false);
      navigate('/profile');
    }, 1000);
  };
  return <div className="min-h-screen flex flex-col items-center justify-center bg-[#0a0a0a] p-4 relative overflow-hidden" data-id="element-487">
      {/* Background Elements */}
      <div className="absolute inset-0 z-0" data-id="element-488">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gradient-to-r from-[#D22B2B]/10 to-transparent rounded-full blur-[120px] opacity-30" data-id="element-489"></div>
        <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-20 mix-blend-overlay" data-id="element-490"></div>
      </div>

      <div className="w-full max-w-md relative z-10" data-id="element-491">
        <Link to="/" className="inline-flex items-center text-xs font-serif uppercase tracking-widest text-gray-500 mb-8 hover:text-[#D22B2B] transition-colors" data-id="element-492">
          <ArrowLeft className="w-3 h-3 mr-2" data-id="element-493" />
          Вернуться к поиску
        </Link>

        <Card className="shadow-[0_0_50px_rgba(0,0,0,0.5)] border-[#333] bg-[#141414]/90 backdrop-blur" data-id="element-494">
          <div className="text-center mb-10" data-id="element-495">
            <h1 className="font-noir text-4xl text-white mb-3" data-id="element-496">
              Вход в систему
            </h1>
            <p className="text-gray-500 font-serif font-light text-sm" data-id="element-497">
              Войдите, чтобы получить доступ к персональным рекомендациям и
              спискам.
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6" data-id="element-498">
            <Input label="Электронная почта" type="email" placeholder="name@example.com" value={email} onChange={e => setEmail(e.target.value)} required data-id="element-499" />

            <Input label="Пароль" type="password" placeholder="••••••••" required data-id="element-500" />

            <Button type="submit" className="w-full mt-4" size="lg" isLoading={isLoading} data-id="element-501">
              Войти
            </Button>
          </form>

          <div className="mt-8 text-center text-xs text-gray-600 font-serif tracking-wide" data-id="element-502">
            Нет аккаунта?{' '}
            <a href="#" className="font-bold text-[#D22B2B] hover:text-white transition-colors" data-id="element-503">
              Зарегистрироваться
            </a>
          </div>
        </Card>
      </div>
    </div>;
}